var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-filter" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          attrs: { size: "small", model: _vm.searchForm, inline: true }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "关键字" } },
            [
              _c("el-input", {
                attrs: { placeholder: "关键词搜索", clearable: "" },
                model: {
                  value: _vm.searchForm.search,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "search", $$v)
                  },
                  expression: "searchForm.search"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("dateOptionSelector", {
                attrs: { options: _vm.dateOptions, multiple: true },
                model: {
                  value: _vm.searchForm.dateTime,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "dateTime", $$v)
                  },
                  expression: "searchForm.dateTime"
                }
              })
            ],
            1
          ),
          _c("el-form-item", [_vm._t("default")], 2)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }